<template>
  <div class="login">
      <div class="po">
        <div class="loginLogo">
          <img src="../../assets/images/loginLogin.png" alt="">
          <span>注册</span>
        </div>
        <div class="login-con">
          <div class="ipt">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <!-- <el-input
                placeholder="请输入真实姓名"
                prop="realName"
                v-model="ruleForm.realName"
                maxlength="10"
                clearable>
              </el-input> -->
                <el-form-item prop="realName">
                  <el-input
                    placeholder="请输入真实姓名"
                    v-model="ruleForm.realName"
                    maxlength="10"
                    >
                  </el-input>
                </el-form-item>
                <el-form-item prop="companyNameCn">
                  <el-input
                    placeholder="企业中文名"
                    v-model="ruleForm.companyNameCn"
                    maxlength="30"
                    >
                  </el-input>
                </el-form-item>
                <el-form-item prop="companyNameEn">
                  <el-input
                    placeholder="企业英文名"
                    v-model="ruleForm.companyNameEn"
                    maxlength="70"
                    >
                  </el-input>
                </el-form-item>
                <el-form-item prop="cityId">
                  <el-autocomplete
                    v-model="ruleForm.cityId"
                    value-key="regionName"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="所在城市"
                    @select="handleSelect"
                    style="margin-top: 10px;width: 100%;">
                  </el-autocomplete>
                </el-form-item>
                <el-form-item prop="mobile">
                  <el-input
                    placeholder="手机号"
                    v-model="ruleForm.mobile"
                    maxlength="11"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    >
                  </el-input>
                </el-form-item>
                <div class="xx">
                  <el-form-item prop="verifyCode">
                    <el-input
                      class="password"
                      placeholder="请输入验证码"
                      maxlength="6"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      v-model="ruleForm.verifyCode" >
                    </el-input>
                    <span :style="disableP2" class="yaz" @click="sendMobileCode">
                        {{ message }}
                      <span style="margin-left: 5px;" v-show="showP" :style="disableP">{{countP}}s</span>
                    </span>
                  </el-form-item>
                </div>
            </el-form>
          </div>


          <el-checkbox style="margin-top: 10px;" v-model="ruleForm.checked">我已阅读并同意《云钱账户注册协议》</el-checkbox>
          <!-- <div :style="nameStatus" class="phone" style="margin-top: 10px;">
            <span style="color:#FF552E;">{{err}}</span>
          </div> -->
          <el-button class="btn" type="primary" @click="successRegister('ruleForm')">注册</el-button>
          <el-button type="text" class="register" @click="login">登录</el-button>
         <!-- <span style="color:red">{{msg2}}</span>
          <span style="color:red">{{msg}}</span> -->
        </div>
      </div>
     <!-- <div class="right-menu">
        <el-dropdown class="hover-effect" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            语言选择<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="zh" :disabled="$i18n.locale == 'zh'">中文</el-dropdown-item>
            <el-dropdown-item command="en" :disabled="$i18n.locale == 'en'">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div> -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'index',
  data() {
    return {
       countryList: [],
       selCountryList: [],
       timeout:  null,
       realName: '',
       companyNameCn: '',
       companyNameEn: '',
       cityId: '',
       countryId: '',
       cityName: '',
       mobile: '',
       verifyCode: '',
       checked: true,
       msg: '',
       msg2:'',
       nameStatus: 'display: none;',
       companyStatus: 'display: none;',
       enStatus: 'display: none;',
       cityStatus: 'display: none;',
       phoneStatus: 'display: none;',
       codeStatus: 'display: none;',
       phoneCode: 'display: none;',
       number: 'display: none;',
       showP: false,
       disableP: '',
       disableP2: '',
       countP: '',
       message: "验证码",
       err:'',
       ruleForm: {
         realName: '',
         companyNameCn: '',
         companyNameEn: '',
         cityName: '',
         checked: false,
         type: [],
         mobile: '',
         verifyCode: ''
       },
       rules: {
         realName: [
           { required: true, message: '请输入真实姓名', trigger: ['change'] },

         ],
         companyNameCn: [
           { required: true, message: '请输入企业中文名', trigger: ['change'] }
         ],
         companyNameEn: [
           { required: true, message: '请输入企业英文名', trigger: ['change'] }
         ],
         cityId: [
           { required: true, message: '请输入城市', trigger: ['change'] }
         ],
         mobile: [
           { required: true, message: '请输入手机', trigger: ['change'] },
           { validator: this.$iValidate.phone, message: '格式不正确', trigger: ['change'] }
         ],
         verifyCode: [
           { required: true, message: '请输入验证码', trigger: ['change'] }
         ]
       },

    }
  },
  created(){

  },
  mounted() {

  },
   methods: {
     countDescP() {
           const TIME_COUNT = 6;
             if (!this.timerP) {
               this.countP = TIME_COUNT;
               this.showP = false;
               this.timerP = setInterval(() => {
               if (this.countP > 0 && this.countP <= TIME_COUNT) {
                 this.disableP = 'pointer-events: none;'
                 this.disableP2 = 'pointer-events: none;'
                 this.showP = true;
                 this.countP--;
                 console.log("shijain ===",this.countP)
                } else {
                 this.disableP = ''
                 this.disableP2 = ''
                 this.showP = false;
                 clearInterval(this.timerP);
                 this.timerP = null;
                 this.message = "重新获取"
                }
               }, 1000)
              }
         // }
       },

     login() {
       this.$router.push({
         name: "login",
         query: {

         }
       })
     },
      // 城市下拉选(检索)
      querySearchAsync(queryString, cb) {
        var results = [];
        if (queryString) {
          this.$axios.get('/country/list',{
              params: {
                "type": "CN",
                "key": queryString
              }
            })
            .then(response=> {
              if(response.code==0){
                results = response.data;
              }
            })
            .catch(error=> {
              console.log(error);
              this.abnormalSituation()
            })
        } else {
          this.$axios.get('/country/list',{
            params: {
              "type": "CN"
            }
          })
          .then(response=> {
            if(response.code==0){
              results = response.data;
            }
          })
          .catch(error=> {
            console.log(error);
            this.abnormalSituation()
          })
        }

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 1000);

      },
      //城市下拉选change事件
      handleSelect(item) {
        console.log(item);
        this.cityId = item.regionId;
        this.countryId = item.countryId;
      },
    //中文注册
    successRegister(formName) {

      this.$refs[formName].validate((valid) => {

        if (valid) {
          let _this = this
               this.$axios.post('/registCn/register', {

                 "realName": _this.ruleForm.realName,
                 "companyNameCn": _this.ruleForm.companyNameCn,
                 "companyNameEn": _this.ruleForm.companyNameEn,
                 "cityId": _this.cityId,
                 "mobile": _this.ruleForm.mobile,
                 "verifyCode": _this.ruleForm.verifyCode,
                 "agreeFlag": _this.ruleForm.checked==true?1:2 //同意是1，不同意是2
               })
               .then(response=> {
                 if(response.code == 0){
                  localStorage.setItem('locale', 'zh')
                  this.$i18n.locale = localStorage.getItem('locale')
                  this.$router.push({
                    name: "personaloverview"
                  })
                 }else{
                     this.$message({
                         type: 'error',
                         message: response.msg
                     });
                 }
                 // if (response.code == -1) {
                 //   // _this.msg = response.msg
                 //    this.phoneCode = 'display:block;'
                 //    this.number = 'display:none;'
                 // }else{
                 //   this.phoneCode = 'display:none;'
                 // }
               })
               .catch(error=> {
                 console.log(error);
                 this.abnormalSituation()
               })
        } else {
          console.log('error submit!!');
          return false;
        }
      })

    },
    //给手机发送验证码
    sendMobileCode() {
      // this.countDescP()
      if(this.disableP2 != 'pointer-events: none;'){
        let _this = this
             this.$axios.get('/registCn/sendMobileCode',{
                 params: {
                   mobile: _this.ruleForm.mobile
                 }
             })
             .then(response=> {
               console.log("给手机发送验证码============",response);
               if(response.code==0){
                  this.countDescP()
                  this.nameStatus = 'display:none;'
               }else{
                 // _this.err = response.msg
                 // this.nameStatus = 'display:block;'
                 this.$message({
                     type: 'error',
                     message: response.msg
                 });
               }
        //        if(response.code == -1){
        //          _this.msg = response.msg
        //        }
        //         if (response.code == 10008) {
        //           this.number = 'display:block;'
        //           this.phoneCode = 'display:none;'
        //         }else{
        //            this.number = 'display:none;'
        //         }
             })
             .catch(error=> {
               console.log(error);
               this.abnormalSituation()
             }); 
      }

    }
  },
  components: {

  }
}
</script>

<style scoped>
  .login{
    background-color: rgb(240, 242, 245);
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/loginBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    background-attachment:fixed
  }
  .login-con{
    width: 365px;
    padding: 40px 30px 50px 30px;
    background-color: #fff;
  }
  .po{
    position: fixed;
    right: 10%;
    top: 9%;
  }
  .btn{
    width: 100%;
    margin-top: 40px;
  }
  .loginLogo{
    z-index: 9999;
    overflow: hidden;
    margin-bottom: 20px;
  }
  .loginLogo img{
    float: left;
    width: 70px;
    height: 50px;
    margin-left: 135px;
  }
  .loginLogo span{
    float: left;
    color: #fff;
    margin-left: 25px;
    font-size: 26px;
    margin-top: 14px;
    letter-spacing: 1.8px;
  }
  .register{
    display: block;
    width: 56px;
    margin: 5px auto 0!important;
  }
  .xx{
   /* overflow: hidden; */
  }
  .password{
    float: left;
    width: 258px;
    margin-top: 10px;
  }
  .yaz{
    float: left;
    width: 92px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    background-color: #C9B25F;
    margin-left: 15px;
    margin-top: 10px;
    cursor: pointer;
  }
  .ipt .el-input{
    margin-top: 10px;
  }
  .right-menu{
    float: right;
    height: 100%;
    line-height: 60px;

    .hover-effect {
      cursor: pointer;
      padding: 0 10px;
      transition: background .5s;

      span{
        outline: none;
      }
      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
  }
  .el-dropdown{
    color: #fff;
  }
  /deep/ .el-form-item__label{
    display: none!important;
  }
  /deep/ .el-form-item__content{
    margin-left: 0!important;
  }
  /deep/ .el-form-item{
    margin-bottom: 13px!important;
  }
</style>
